<template>
    <section class="cmn-section testemonial_section" v-if="testimonials && testimonials.length">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box no_border_heading">
                            <h1
                                class="heading1 section_heading testimonial_heading position-relative text-center"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Testimonial</span
                                >
                            </h1>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="owl-carousel testemonial testimonial_carousel mx-auto">
                            <div
                                class="item testimonial_item"
                                v-for="testimonial in testimonials"
                                :key="testimonial.id"
                            >
                                <div class="testemonial_content testimonial_card">
                                    <div class="testimonial_user_row">
                                        <div class="user_image">
                                        <img
                                            :src="testimonial.userphoto"
                                            alt=" "
                                        />
                                    </div>
                                    <div class="user_content">
                                            <h4 class="testimonial_user_name mb-0">
                                            {{ testimonial.username }}
                                        </h4>
                                        </div>
                                    </div>
                                        <div
                                        class="rating testimonial_rating d-flex align-items-center"
                                        >
                                            <img
                                                src="/maincss/images/star.svg"
                                                alt=" "
                                            class="mw-auto w-auto mr_6"
                                                v-for="n in testimonial.rating"
                                                :key="'image' + (testimonial.id || 'x') + '_' + n"
                                            />
                                        </div>
                                    <p class="text_black font_size_15 testimonial_desc mb-0">
                                        {{ testimonial.description }}
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          
        </section>
</template>

<script>
export default {
    name: "TestimonialsSection",
    props: {
        testimonials: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        testimonials(newVal) {
            if (newVal && newVal.length) {
                this.$nextTick(() => this.scheduleCarouselInit());
            }
        }
    },
    mounted() {
        if (this.testimonials && this.testimonials.length) {
            this.$nextTick(() => this.scheduleCarouselInit());
        }
    },
    beforeDestroy() {
        if (typeof $ !== "undefined") {
            const $el = $(this.$el).find(".testemonial");
            if ($el.length > 0 && $el.data("owl.carousel")) {
                $el.trigger("destroy.owl.carousel");
            }
        }
    },
    methods: {
        scheduleCarouselInit() {
            let retryCount = 0;
            const maxRetries = 12;
            const tryInit = () => {
                const initialized = this.initCarousel();
                if (!initialized && retryCount < maxRetries) {
                    retryCount += 1;
                    setTimeout(tryInit, 200);
                }
            };
            tryInit();
        },
        initCarousel() {
            if (typeof $ === "undefined" || !$.fn || !$.fn.owlCarousel) return false;
            const $el = $(this.$el).find(".testemonial");
            if ($el.length === 0) return false;
            if ($el.data("owl.carousel")) {
                $el.trigger("destroy.owl.carousel");
            }
            $el.owlCarousel({
                loop: false,
                margin: 18,
                nav: true,
                dots: false,
                responsive: {
                    1: { items: 1 },
                    600: { items: 1 },
                    1000: { items: 3, margin: 18 },
                    1200: { items: 3 }
                }
            });
            return true;
        }
    }
};
</script>